import { Grid } from "@mui/material";
import DeviceReportingForm from "components/Forms/DeviceReportingForm";
import LiveViewReportingForm from "components/Forms/LiveViewReportingForm";
import PropTypes from "prop-types";
import moment from "moment";
import { useState } from "react";
import { deviceViewWrapper } from "utils/wrapper";

function GenerateReportTab({ uuid, deviceLayout }) {

    const [deviceReportInputs, setDeviceReportInputs] = useState({ start_date: moment().subtract(7, 'days'), start_time: moment().subtract(7, 'days'), end_time: moment().subtract(6, 'days'), end_time: moment().subtract(6, 'days') })
    const [liveviewReportInputs, setLiveviewReportInputs] = useState({ start_date: moment().subtract(1, 'days'), start_time: moment().subtract(1, 'days') })

    return (
        deviceViewWrapper(
            <DeviceReportingForm uuid={uuid} reportInputs={deviceReportInputs} setReportInputs={setDeviceReportInputs} />,
            <LiveViewReportingForm uuid={uuid} reportInputs={liveviewReportInputs} setReportInputs={setLiveviewReportInputs} />,
            deviceLayout
        )
    );
}

GenerateReportTab.propTypes = {
    uuid: PropTypes.string,
    deviceLayout: PropTypes.string
}

export default GenerateReportTab;